import {
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalBody,
  MDBModalFooter,
  MDBCheckbox,
  MDBBtn,
  MDBAutocomplete,
  MDBIcon,
} from "mdb-react-ui-kit";
import ReactDOM from "react-dom";
import React, { useEffect, useRef, useState } from "react";
import { customSearch } from "../CustomSearchUtil/CustomSearch";
const DropDown = ({
  data = [{}],
  title,
  disp,
  placeholder,
  onSelect,
  nodedata,
  skipFlag = false, 
  showhyperlink = false,
  onLinkClick,
  itemContent,
}) => {
  const autocompleteRef = useRef();
  const [customData, setCustomData] = useState(data);
  const [selected, setSelected] = useState(title);
  const [dropdownOpen, setDropdownOpen] = useState();

  const [tempSelected, setTempSelected] = useState(null); // Temporary value before confirmation
  const [open, setOpen] = useState(false);
  const [dontAskAgain, setDontAskAgain] = useState(false);

  useEffect(() => {
    const skipConfirmation = localStorage.getItem("skipDropdownConfirmation");
    if (skipConfirmation === "true" && tempSelected !== null) {
      setSelected(tempSelected);
    }
  }, [tempSelected]);

  const handleClose = (value) => {
    setOpen(false);
    console.log(nodedata.selected_object);
    try {
      if (nodedata && nodedata.selected_object && nodedata.selected_object != "undefined" && Object.keys(nodedata.selected_object).length > 1) {
        if (nodedata.selected_object.label) {
          setSelected(nodedata.selected_object.label);
        } else {
          setSelected(nodedata.selected_object.title? nodedata.selected_object.title : "");
        }
      } 
    } catch (e) {
      console.log("Error : " + e);
    }

    console.log("22222222222222222222222");
  };

  const handleConfirm = () => {
    if (dontAskAgain) {
      localStorage.setItem("skipDropdownConfirmation", "true");
    }
    setSelected(tempSelected);
    onSelect(tempSelected);
    setOpen(false);
  };

  const handleFocus = (event) => {
    setDropdownOpen()
    if (event.target.value != "") {
      event.target.select();
      setCustomData(data);
    }
  };

  useEffect(() => {
    if (nodedata && nodedata.selected_object) {
      if (nodedata.selected_object.label) {
        setSelected(nodedata.selected_object.label);
      } else {
        setSelected(nodedata.selected_object.title);
      }
    }
  }, [nodedata]);

  const handleSelect = (value) => {
    if (!nodedata || !nodedata.selected_object || nodedata.selected_object == "undefined" || Object.keys(nodedata.selected_object).length === 1) {
      onSelect(value);
      return;
    }
    const skipConfirmation = localStorage.getItem("skipDropdownConfirmation");
    if (skipConfirmation === "true" || skipFlag === true) {
      setSelected(value);
      onSelect(value);
    } else {
      setTempSelected(value);
      setOpen(true); // Show modal
    }
  };

  const onCustomSearch = (value) => {
    try {
      let trimvalue = value.trim().toLowerCase();
      setCustomData(customSearch(data, trimvalue, ['name', 'title', 'extensions'])
     
      );
    } catch (e) {
      console.error("Error filtering data:", e);
    }
  };

  const handleLink = (e) => {
    setDropdownOpen(false)
    onLinkClick(e);
  };

  useEffect(() => {
    if (autocompleteRef.current) {
      autocompleteRef.current.value = selected;
    }
  }, [selected]);
  useEffect(() => {
    setSelected(title);
  }, [title]);

  function setTSelected(value, title) {
    if (value === "Create New" && title) {
      setSelected(title);
      return;
    }
    setSelected(value);
  }

  function handleBlur(tvalue) {
    if(tvalue && tvalue.target && tvalue.target.value === "") {
      setSelected(title);
      return;
    }
    setDropdownOpen()
    console.log(tvalue);
    const flitData =
      tvalue && tvalue.target.value.trim()
        ? data.filter((tdataObj) => {
          const searchField =
            tdataObj.name || tdataObj.title || tdataObj.label || ""; // Use `name` first, then `title`, or fallback to an empty string
          return searchField
            .toLowerCase()
            .startsWith(tvalue.target.value.toLowerCase());
        })
        : [{}];

    console.log("111111111111111111111111111111111111111111111111");
    console.log(flitData);
    if (flitData.length == 0) {
      if (selected) {
        setSelected(title);
      } else {
        setSelected(null);
      }
    }
  }

  return (
    <>
      <div className="nodeSelectLinkIcon ">
        <div className="autocomplete-custom-item-content">
          <div className="autocomplete-custom-item-title">
            <MDBAutocomplete
              ref={autocompleteRef}
              data={customData}
              title={selected}
              value={selected}
              displayValue={disp || ((row) => row.name)}
              placeholder={ placeholder ? placeholder : "Choose .."}
              onClick={handleFocus}
              onBlur={handleBlur}
              onChange={(value) => setTSelected(value)}
              onSelect={(e) => handleSelect(e)}
              onSearch={onCustomSearch}
              itemContent={itemContent || disp || ((row) => row.name)}
              open={dropdownOpen}
            />
          </div>
        </div>
        {showhyperlink && (
          <>
            <MDBIcon
              fas
              icon="external-link-square-alt"
              className="nodeLinkIcon"
              onClick={(e) => handleLink(e)}
            />
          </>
        )}
      </div>
      {/* Render Modal Using React Portals */}
      {ReactDOM.createPortal(
        <MDBModal open={open} setOpen={setOpen} tabIndex="-1">
          <MDBModalDialog className="modal-dialog-centered">
            <MDBModalContent>
              <MDBModalHeader>
                <h5 className="modal-title">Confirm Selection</h5>
                <MDBBtn
                  className="btn-close"
                  color="none"
                  onClick={() => handleClose()}
                ></MDBBtn>
              </MDBModalHeader>
              <MDBModalBody>
                <p>
                Are you sure you want to change the selection? This action may cause you to lose the current flow of this node if one has been created.
                </p>
                <MDBCheckbox
                  label="Do not ask again"
                  checked={dontAskAgain}
                  onChange={(e) => setDontAskAgain(e.target.checked)}
                />
              </MDBModalBody>
              <MDBModalFooter>
                <MDBBtn color="secondary" onClick={() => handleClose()}>
                  Cancel
                </MDBBtn>
                <MDBBtn color="success" onClick={handleConfirm}>
                  Confirm
                </MDBBtn>
              </MDBModalFooter>
            </MDBModalContent>
          </MDBModalDialog>
        </MDBModal>,
        document.body // Render outside the node UI
      )}
    </>
  );
};
export default DropDown;
